module.exports = __webpack_public_path__ + "static/media/img-02.bb65828a.jpg";